<template>
  <div id="app">
    <Header v-if="showHeader"></Header>
    <div class="router" v-if="showUserHeader">
      <UserCenterHeader></UserCenterHeader>
      <div class="user-center">
        <UserCenterTab></UserCenterTab>
        <router-view style="width: 100%" />
      </div>
    </div>
    <router-view v-else class="router" />
    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUserInfo } from "./api/user.js";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import UserCenterHeader from "@/components/UserCenterHeader";
import UserCenterTab from "@/components/UserCenterTab";

export default {
  name: "App",
  components: { Header, Footer, UserCenterHeader, UserCenterTab },
  computed: {
    ...mapGetters(["showHeader", "showUserHeader"]),
  },
  watch: {
    $route(to, form) {
      if (
        to.path === "/person-info" ||
        to.path === "/score" ||
        to.path === "/exchange-record" ||
        to.path === "/my-study" ||
        to.path === "/study-remind" ||
        to.path === "/data-center" ||
        to.path === "/my-meeting" ||
        to.path === "/my-question" ||
        to.path === "/my-message" ||
        to.path === "/feedback"
      ) {
        this.$store.dispatch("setShowUserHeader", true);
      } else {
        this.$store.dispatch("setShowUserHeader", false);
      }
      // 设置header
      if (
        to.path === "/exam/survey" ||
        to.path === "/exam/surveyResult" ||
        to.path === "/exam/paper" ||
        to.path === "/exam/paperResult"
      ) {
        this.$store.dispatch("setHeader", false);
      } else {
        this.$store.dispatch("setHeader", true);
      }
    },
  },
  mounted() {
    if (
      this.$route.path === "/person-info" ||
      this.$route.path === "/score" ||
      this.$route.path === "/exchange-record" ||
      this.$route.path === "/my-study" ||
      this.$route.path === "/study-remind" ||
      this.$route.path === "/data-center" ||
      this.$route.path === "/my-meeting" ||
      this.$route.path === "/my-question" ||
      this.$route.path === "/my-message" ||
      this.$route.path === "/feedback"
    ) {
      this.$store.dispatch("setShowUserHeader", true);
    } else {
      this.$store.dispatch("setShowUserHeader", false);
    }
    const script = document.createElement("script");
    script.src =
      "https://s4.cnzz.com/z_stat.php?id=1280213078&web_id=1280213078";
    script.language = "JavaScript";
    document.body.appendChild(script);
  },
  created() {
    getUserInfo().then((res) => {
      if (res.data.userType == 1 || res.data.userType == 5) {
        window.localStorage.setItem("neiwei", true);
      } else {
        window.localStorage.setItem("neiwei", false);
      }
      console.log(window.localStorage.getItem("neiwei"));
    });
  },
  methods: {},
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: #f4f4f4;
  box-sizing: border-box;
  // padding: 9.57rem 0 7.13rem;
  min-height: 100vh;

  .breadcrumb {
    margin: 1.44rem 0;
    .el-breadcrumb__item {
      color: #aaaaaa;
      .el-breadcrumb__inner {
        color: #aaaaaa;
      }
      .is-link {
        color: #07a905;
      }
    }
  }
}
.router {
  /* width: 62.87rem; */
  width: 1000px;
  margin: 0 auto;
  min-height: calc(100vh - 9.57rem - 120px);
  .user-center {
    display: flex;
    background: #ffffff;
    margin-top: 1rem;
    padding-top: 1.32rem;
    // height: 35.63rem;
  }
}
body::-webkit-scrollbar {
  width: 0;
}
div {
  box-sizing: border-box;
}
.over-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue